import type { PapeisObraDialogProps } from "./types-papeis-obra-dialog";
import { usePapeisObraDialog } from "./use-papeis-obra-dialog";
import { PapeisObraDialogView } from "./view-papeis-obra-dialog";

/** Modal "Definir Papel na Obra" (HU 2033): lista, cadastro, edição e inativação de papéis. */
export function PapeisObraDialog(props: PapeisObraDialogProps) {
  const vm = usePapeisObraDialog(props);

  return <PapeisObraDialogView {...vm} />;
}

export type * from "./types-papeis-obra-dialog";
